export const LANGUAGE_STORAGE_KEY = 'LANGUAGE';
